import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/productoverview',
    name: 'productoverview',
    component: () => import('../views/Productoverview.vue')
  },
  {
    path: '/productlist',
    name: 'productlist',
    component: () => import('../views/Productlist.vue')
  },
  {
    path: '/brandlist',
    name: 'brandlist',
    component: () => import('../views/Brandlist.vue')
  },
  {
    path: '/newslist',
    name: 'newslist',
    component: () => import('../views/Newslist.vue')
  },
  {
    path: '/recruitment',
    name: 'recruitment',
    component: () => import('../views/Recruitment.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/About.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
